import type { IconProps } from './../../models/icon';

export function HamburgerIcon({ width = 24, height = 24, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill="currentColor"
        d="M0 3.66667C0 2.74479 0.766071 2 1.71429 2H22.2857C23.2339 2 24 2.74479 24 3.66667C24 4.58854 23.2339 5.33333 22.2857 5.33333H1.71429C0.766071 5.33333 0 4.58854 0 3.66667ZM0 12C0 11.0781 0.766071 10.3333 1.71429 10.3333H22.2857C23.2339 10.3333 24 11.0781 24 12C24 12.9219 23.2339 13.6667 22.2857 13.6667H1.71429C0.766071 13.6667 0 12.9219 0 12ZM24 20.3333C24 21.2552 23.2339 22 22.2857 22H1.71429C0.766071 22 0 21.2552 0 20.3333C0 19.4115 0.766071 18.6667 1.71429 18.6667H22.2857C23.2339 18.6667 24 19.4115 24 20.3333Z"
      />
    </svg>
  );
}
